import { DeviceSubordinate } from "../Core/DeviceSubordinate";
import { Device } from "../Core/Device";
import { HashSet } from "../Utils/HashSet";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { MacAddress } from "../Core/MacAddress";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";

  //export interface InfoSetEntriesJson<K> {
  //  entries: K[];
  //}

  //export interface InfoSetJson {
  //  system_info: SystemInfoJson;
  //  product_info: ProductInfoJson;
  //  asset_info: InfoSetEntriesJson<AssetEntryJsonWrapper>;
  //  bp_info: InfoSetEntriesJson<BridgePortEntryJsonWrapper>;
  //  if_info: InfoSetEntriesJson<IfEntryJsonWrapper>;
  //  if_arp_info: InfoSetEntriesJson<ArpEntryJsonWrapper>;
  //  bp_fdb_info: InfoSetEntriesJson<BridgePortFdbEntryJson>;

  //  ip_info: InfoSetEntriesJson<IpAddressEntryJsonWrapper>;

  //  inst_sw_info: InfoSetEntriesJson<InstalledSoftwareEntryJsonWrapper>;

  //  vh_info: VirtualHostInfoJson;
  //  vms_info: InfoSetEntriesJson<VirtualMachineInfoJsonWrapper>;

  //  w32_comp_sys_info: Win32_ComputerSystemInfoJson;
  //  w32_os_info: Win32_OperatingSystemInfoJson;
  //  w32_ddrv_info: InfoSetEntriesJson<Win32_DiskDriveEntryJsonWrapper>;
  //  w32_ldsk_info: InfoSetEntriesJson<Win32_LogicalDiskEntryJsonWrapper>;
  //  w32_proc_info: InfoSetEntriesJson<Win32_ProcessorEntryJsonWrapper>;
  //  w32_net_ad_cfg_info: InfoSetEntriesJson<Win32_NetworkAdapterConfigEntryJsonWrapper>
  //  w32_inst_sw_info: InfoSetEntriesJson<any>;
  //  attr_info: InfoSetEntriesJson<any>;
  //  ap_client_info: InfoSetEntriesJson<any>;
  //  ap_if_info: InfoSetEntriesJson<any>;
  //  ap_info: InfoSetEntriesJson<any>;
  //  if_cdp_info: InfoSetEntriesJson<any>;
  //  entity_info: InfoSetEntriesJson<any>;
  //  ip_phone_info: IpPhoneInfoJson;
  //  ip_phones_info: InfoSetEntriesJson<any>;
  //  ip_route_info: IpRouteInfoJson;
  //}

  export enum Age { Old, New };

  export abstract class InfoSet extends DeviceSubordinate implements ObjectSerializer {

    //public static AllFromJson(json: InfoSetJson, device: Device): Dictionary<string, InfoSet> {
    //  var result = new Dictionary<string, InfoSet>();

    //  if (json.system_info !== undefined)
    //    result.Add(InfoSetNames.SystemInfo, SystemInfo.FromJson(json.system_info, device));

    //  if (json.product_info !== undefined)
    //    result.Add(InfoSetNames.ProductInfo, ProductInfo.FromJson(json.product_info, device));

    //  if (json.asset_info !== undefined)
    //    result.Add(InfoSetNames.AssetTable, AssetTable.FromJson(json.asset_info, device));

    //  if (json.bp_info !== undefined)
    //    result.Add(InfoSetNames.BridgePortTable, BridgePortTable.FromJson(json.bp_info, device));

    //  if (json.if_info !== undefined)
    //    result.Add(InfoSetNames.IfTable, IfTable.FromJson(json.if_info, device));

    //  if (json.if_arp_info !== undefined)
    //    result.Add(InfoSetNames.IfArpTable, IfArpTable.FromJson(json.if_arp_info, device));

    //  if (json.bp_fdb_info !== undefined)
    //    result.Add(InfoSetNames.BridgePortFdbTable, BridgePortFdbTable.FromJson(json.bp_fdb_info, device));

    //  if (json.ip_info !== undefined)
    //    result.Add(InfoSetNames.IpAddressTable, IpAddressTable.FromJson(json.ip_info, device));

    //  if (json.inst_sw_info !== undefined)
    //    result.Add(InfoSetNames.InstalledSoftwareTable, InstalledSoftwareTable.FromJson(json.inst_sw_info, device));

    //  if (json.vh_info !== undefined)
    //    result.Add(InfoSetNames.VirtualHostInfo, VirtualHostInfo.FromJson(json.vh_info, device));

    //  if (json.vms_info !== undefined)
    //    result.Add(InfoSetNames.VirtualMachineTable, VirtualMachineTable.FromJson(json.vms_info, device));

    //  if (json.w32_comp_sys_info !== undefined)
    //    result.Add(InfoSetNames.Win32_ComputerSystemInfo, Win32_ComputerSystemInfo.FromJson(json.w32_comp_sys_info, device));

    //  if (json.w32_os_info !== undefined)
    //    result.Add(InfoSetNames.Win32_OperatingSystemInfo, Win32_OperatingSystemInfo.FromJson(json.w32_os_info, device));

    //  if (json.w32_ddrv_info !== undefined)
    //    result.Add(InfoSetNames.Win32_DiskDriveTable, Win32_DiskDriveTable.FromJson(json.w32_ddrv_info, device));

    //  if (json.w32_ldsk_info !== undefined)
    //    result.Add(InfoSetNames.Win32_LogicalDiskTable, Win32_LogicalDiskTable.FromJson(json.w32_ldsk_info, device));

    //  if (json.w32_proc_info !== undefined)
    //    result.Add(InfoSetNames.Win32_ProcessorTable, Win32_ProcessorTable.FromJson(json.w32_proc_info, device));

    //  if (json.attr_info !== undefined)
    //    result.Add(InfoSetNames.AttributeInfo, AttributeInfo.FromJson(json.attr_info, device));

    //  if (json.ap_client_info !== undefined)
    //    result.Add(InfoSetNames.ApClientTable, ApClientTable.FromJson(json.ap_client_info, device));

    //  if (json.ap_if_info !== undefined)
    //    result.Add(InfoSetNames.ApIfTable, ApIfTable.FromJson(json.ap_if_info, device));

    //  if (json.ap_info !== undefined)
    //    result.Add(InfoSetNames.ApTable, ApTable.FromJson(json.ap_info, device));

    //  if (json.if_cdp_info !== undefined)
    //    result.Add(InfoSetNames.IfCdpTable, IfCdpTable.FromJson(json.if_cdp_info, device));

    //  if (json.entity_info !== undefined)
    //    result.Add(InfoSetNames.EntPhysicalTable, EntPhysicalTable.FromJson(json.entity_info, device));

    //  if (json.w32_inst_sw_info !== undefined)
    //    result.Add(InfoSetNames.Win32_InstalledSoftwareTable, Win32_InstalledSoftwareTable.FromJson(json.w32_inst_sw_info, device));

    //  if (json.w32_net_ad_cfg_info !== undefined)
    //    result.Add(InfoSetNames.Win32_NetworkAdapterConfigTable, Win32_NetworkAdapterConfigTable.FromJson(json.w32_net_ad_cfg_info, device));

    //  if (json.ip_phones_info !== undefined)
    //    result.Add(InfoSetNames.IpPhoneTable, IpPhoneTable.FromJson(json.ip_phones_info, device));

    //  if (json.ip_phone_info !== undefined)
    //    result.Add(InfoSetNames.IpPhoneInfo, IpPhoneInfo.FromJson(json.ip_phone_info, device));

    //  if (json.ip_route_info !== undefined)
    //    result.Add(InfoSetNames.IpRouteTable, IpRouteTable.FromJson(json.ip_route_info, device));

    //  return result;
    //}

    constructor(device: Device) {
      super(device);
    }

    public get HasIpAddresses(): boolean {
      return false;
    }

    public get IpAddresses(): HashSet<IpAddress> {
      return new HashSet<IpAddress>();
    }

    public get HasMacAddresses(): boolean {
      return false;
    }

    public get MacAddresses(): HashSet<MacAddress> {
      return new HashSet<MacAddress>();
    }

    public get HasIpSightings(): boolean {
      return false;
    }

    public get IpSightings(): HashSet<IpAddress> {
      return new HashSet<IpAddress>();
    }

    public get HasMacSightings(): boolean {
      return false;
    }

    public get MacSightings(): HashSet<MacAddress> {
      return new HashSet<MacAddress>();
    }

	//public abstract Write(obj: any, context: any): void;
	//public abstract Read(obj: any, context: any): void;

	public Write(obj: any, context: any): void {
		throw new Error("Unimplemented Write method");
	}

	public Read(obj: any, context: any): void {
		throw new Error("Unimplemented Read method");
	}

  }
